module.exports = __webpack_public_path__ + "media/images/flextab_devices-530x610-43cc6b0207d146d5bfb004d58235efaf.png";